import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import IntlMessages from "../util/IntlMessages";
import {
  Input,
  Row,
  Col,
  Form,
  Modal,
  message,
  Spin,
  InputNumber,
} from "antd";
import ds from "../Services/DataServices";
import { ApplyCustomerAccountDetails, notAllowMsgCheck, checkRightspermissions, isEmptyObject, customParse } from "../appRedux/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  loadShowIssueCreditModal
} from "../appRedux/actions/MainSale";
import {
  loadCustomerSearchData,
  loadSaleHistoryCustomerShow,
} from "../appRedux/actions/Sell";
import { BEHAVIOUR_TYPE } from "../Services/DataServices";

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 },
  },
};

const IssueStoreCredit = (props) => {
  const { allow, name, curr, returnStoreCredit } = props;
  const getCustomerSId = props.id && props.id != "" ? props.id : false;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const history = useHistory();

  const getShowIssueCreditModal = useSelector(
    ({ MainSale }) => MainSale.getShowIssueCreditModal
  );
  const getCustomerSearchData = useSelector(
    ({ Sell }) => Sell.customerSearchData
  );
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );
  const getIsStoreCreditEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsStoreCreditEnabled
  );
  const getIsRefundSale = useSelector(
    ({ MainSale }) => MainSale.getIsRefundSale
  );
  const getStorePaymentTypes = useSelector(
    ({ MainSale }) => MainSale.getStorePaymentTypes
  );
  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  );

  const [confirmLoading, setConfirmLoading] = useState(false);
  const [showIssue, setShowIssue] = useState(false);
  const [issued, setIssued] = useState(0);
  const [total, setTotal] = useState(0);

  async function postIssueCredit(body) {
    if (allow) {
      const createReq = ds.postCusStoreCredit(body, BEHAVIOUR_TYPE.POST);
      await createReq
        .then((data) => {
          setConfirmLoading(false);
          if (data && data.status && data.status.toLowerCase().includes("ok")) {
            setShowIssue(true);
            setTotal(data.total);
            setIssued(data.issued);
            form.resetFields();
            let customerData = getCustomerSearchData;
            customerData.storeCredit = customParse(data.total);
            ApplyCustomerAccountDetails(
              dispatch,
              customerData,
              getStorePaymentTypes,
              getDefaultDecimalPlaces,
              getIsRefundSale,
              returnStoreCredit,
              getIsLoyaltyEnabled,
              getIsStoreCreditEnabled,
            );
            dispatch(loadCustomerSearchData(customerData));
          }
        })
        .catch((e) => {
          notAllowMsgCheck(e);
          setConfirmLoading(false);
        });
    } else message.warn("Not allowed");
  }

  const handleCancel = () => {
    dispatch(loadShowIssueCreditModal(false));
    setShowIssue(false);
    setTotal(0);
    setIssued(0);
    form.resetFields();
  };

  const handleOk = (values) => {
    if (getCustomerSId && allow) {
      const body = {
        CustomerID: getCustomerSId,
        Note: values.note,
        Amount: values.amount
      }
      setConfirmLoading(true);
      postIssueCredit(body);
    }
    else {
      message.warn("Something Wrong, Try Later...");
    }
  };

  return (
    <Modal
      title={<IntlMessages id="mainsale.sell.issuestorecred" />}
      visible={getShowIssueCreditModal}
      okText={!showIssue && <IntlMessages id="mainsale.sell.givestorecred" />}
      cancelText={<IntlMessages id="common.resource.cancel" />}
      confirmLoading={confirmLoading}
      onCancel={handleCancel}
      centered={true}
      onOk={() => {
        if (showIssue) {
          dispatch(loadSaleHistoryCustomerShow(false));
          handleCancel();
        } else {
          form
            .validateFields()
            .then((values) => {
              handleOk(values);
            })
            .catch((info) => {
            });
        }
      }}
    >
      <Spin
        tip={<IntlMessages id="sell.cashlisting.cashloading" />}
        spinning={confirmLoading}
        size="large"
      >
        <div>
          <h3>
            <strong>
              {name}
            </strong>
          </h3>
          {!showIssue ? <>
            <Form
              {...formItemLayout}
              form={form}
              name="IssueCredit"
              initialValues={{
                prefix: "86",
              }}
              scrollToFirstError
            >
              <Form.Item
                className="ant-form-item-label-custom ant-form-margin-right"
                name="amount"
                label={
                  <span>
                    <IntlMessages id="mainsale.sell.storecredvalue" />

                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter amount",
                  },
                ]}
              >
                <InputNumber type="number" style={{ width: "100%" }} min={0} placeholder="Amount" />
              </Form.Item>
              <Form.Item
                className="ant-form-item-label-custom ant-form-margin-right"
                name="note"
                label={
                  <span>
                    <IntlMessages id="products.brands.description" />

                  </span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please enter description",
                    whitespace: true,
                  },
                ]}
              >
                <Input placeholder="Description" />
              </Form.Item>
            </Form>
          </> :
            <div style={{ marginTop: 18 }}>
              <Row gutter={28}>
                <Col>
                  <h5>
                    <IntlMessages id="mainsale.sell.issuedcredit" />
                  </h5>
                </Col>
                <Col>
                  <h5>
                    <strong>
                      {`${curr} ${issued}`}
                    </strong>
                  </h5>
                </Col>
              </Row>

              <Row gutter={22}>
                <Col>
                  <h5>
                    <IntlMessages id="mainsale.sell.issuedbalance" />
                  </h5>
                </Col>
                <Col>
                  <h5>
                    <strong>
                      {`${curr} ${total}`}
                    </strong>
                  </h5>
                </Col>
              </Row>
            </div>
          }
        </div>
      </Spin>
    </Modal>
  );
};
export default IssueStoreCredit;
